import axios from 'axios';
import {token} from '../services/Authentication'

export default class DashboardService {

    static searchById(id, bearerToken = null) {
      
        return axios({
          method: 'get',
          url: `${process.env.REACT_APP_URL_DATASET}/dashboard/${id}`,
          headers: {              
            "authorization": bearerToken ? bearerToken : token(), 
          }
        })
        .then((res) => res, (error) => {throw error})
      }

    static searchAllDataById(id) {

        return axios({
            method: 'get',
            url: `${process.env.REACT_APP_URL_DATASET}/dashboard/edit/${id}`,
            headers: {
                "authorization": token(),
            }
        })
            .then((res) => res, (error) => {throw error})
    }

    static searchAll(params) {

        return axios({
          method: 'post',
          url: `${process.env.REACT_APP_URL_DATASET}/dashboard/search`,
          headers: {
            "authorization": token(),
          },
          data: params
        })
        .then((res) => res, (error) => {throw error})
    }

    static save(param) {

        return axios({
            method: 'post',
            url: `${process.env.REACT_APP_URL_DATASET}/dashboard`,
            headers: {
                "authorization": token(),
                "Content-Type": "application/json"
            },
            data:param,
        })
            .then((res) => res, (error) => {throw error})
    }

    static delete(id) {

        return axios({
            method: 'get',
            url: `${process.env.REACT_APP_URL_DATASET}/dashboard/delete/${id}`,
            headers: {
                "authorization": token(),
            }
        })
            .then((res) => res, (error) => {throw error})
    }

    static copy(id) {

        return axios({
            method: 'get',
            url: `${process.env.REACT_APP_URL_DATASET}/dashboard/copy/${id}`,
            headers: {
                "authorization": token(),
            }
        })
            .then((res) => res, (error) => {throw error})
    }




}